/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateOktaVerificationKeyInput = {
    email?: string | null | undefined;
    issuer?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createOktaVerificationKeyMutationVariables = {
    input: CreateOktaVerificationKeyInput;
};
export type createOktaVerificationKeyMutationResponse = {
    readonly createOktaVerificationKey: {
        readonly key: string | null;
        readonly oktaClientId: string | null;
        readonly oktaUrl: string | null;
    } | null;
};
export type createOktaVerificationKeyMutation = {
    readonly response: createOktaVerificationKeyMutationResponse;
    readonly variables: createOktaVerificationKeyMutationVariables;
};



/*
mutation createOktaVerificationKeyMutation(
  $input: CreateOktaVerificationKeyInput!
) {
  createOktaVerificationKey(input: $input) {
    key
    oktaClientId
    oktaUrl
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateOktaVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOktaVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createOktaVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oktaClientId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oktaUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createOktaVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createOktaVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createOktaVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createOktaVerificationKeyMutation(\n  $input: CreateOktaVerificationKeyInput!\n) {\n  createOktaVerificationKey(input: $input) {\n    key\n    oktaClientId\n    oktaUrl\n  }\n}\n"
  }
};
})();
(node as any).hash = '2167be95e7dfd72710e98f0bdbe4742b';
export default node;
